import { useMutation } from "@tanstack/react-query";
import { IDealership, TInventory } from "types/APIParameters";
import { EProviderInitials } from "types/APIProviderRanks";
import fetchUtil from "utils/fetchData";

export enum EUserModules {
    PagePreference = "v2/users/user_page_preference",
}

interface IParams {
  dealership_uid: string;
}

interface PagePreferenceForm {
    settings: object;
}

interface PagePreferenceResponse {
    message: string;
}

type TFetchForm<T> = T extends EUserModules.PagePreference
  ? PagePreferenceForm
  : {};

type TFetchResponse<T> = T extends EUserModules.PagePreference
  ? PagePreferenceResponse
  : unknown;

interface IOptions {
  module: EUserModules;
  params?: IParams;
}

const usePostUsers = <T extends IOptions["module"]>({
  module,
  params,
}: IOptions) =>
  useMutation((form: TFetchForm<T>) => {
    return fetchUtil<TFetchResponse<T>>({
      body: form,
      isAuth: true,
      method: "POST",
      params,
      url: `${process.env.REACT_APP_API_URL || ""}api${
        module ? `/${module}` : ""
      }`,
    })();
  });

export default usePostUsers;
